/**
 * MathLive 가 쓰는 KaTeX 글꼴 위치. `public/fonts/mathlive/<버전>/` 에 패키지의
 * `dist/fonts` 를 그대로 복사해 둔다. `/fonts/*.woff2` 는 immutable 1년 캐시라
 * mathlive 버전을 올리면 새 버전 폴더로 복사하고 이 값을 바꾼다(mathliveFonts.test.ts 가 검사).
 */
export const MATHLIVE_FONTS_VERSION = '0.104.0';

export const MATHLIVE_FONTS_DIRECTORY = `/fonts/mathlive/${MATHLIVE_FONTS_VERSION}`;
